import React, {useEffect, useMemo, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import HighlightedElementComponent from '../../../../components/slides/form/part/highlighted';
import SlideSettingsForm from '../../../../components/slides/form/slideSettings/SlideSettingsForm';
import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';
import {setSidePanelContentAction} from '../../../../store/actions/grid';
import {setHighlightedElementIndex} from '../../../../store/actions/slide';
import {SidePanelContent} from '../../../../store/actions/types/grid.types';
import {sidePanelContentSelector} from '../../../../store/selectors/grid';
import {selectedSlideSelector} from '../../../../store/selectors/slide.selectors';
import EditPresSidebar from '../../../components/EditPresSidebar';
import {HIGHLIGHTED_ELEMENT_INITIAL} from '../PresentationEditPage';
import {useHighlightedElement} from '../../../../utils/hooks/slideUpdates/useSetSlideElement';

function SidePanelWrapper(): JSX.Element {
    const dispatch = useDispatch();

    const sidePanelContent = useSelector(sidePanelContentSelector);
    const slide = useSelector(selectedSlideSelector);
    const highlightedElement = useHighlightedElement();

    const isPlaceholderElement = useMemo(() => {
        return highlightedElement.type === ELEMENT.PLACEHOLDER;
    }, [highlightedElement]);

    const highlightedRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        highlightedRef.current?.scrollTo(0, 0);
    }, [highlightedElement.id]);

    useEffect(() => {
        dispatch(setSidePanelContentAction(SidePanelContent.SLIDE));
    }, [dispatch, slide?._id]);

    useEffect(() => {
        if (sidePanelContent !== SidePanelContent.HIGHLIGHTED_ELEMENT) {
            dispatch(setHighlightedElementIndex(HIGHLIGHTED_ELEMENT_INITIAL));
        }
    }, [dispatch, sidePanelContent]);

    const isPlaceholderHighlighted = sidePanelContent === SidePanelContent.HIGHLIGHTED_ELEMENT && isPlaceholderElement;
    const isElementsTabActive = sidePanelContent === SidePanelContent.ELEMENTS;
    const isHighlightedElementsTabActive = sidePanelContent === SidePanelContent.HIGHLIGHTED_ELEMENT && !isPlaceholderElement;
    const isSlideTabActive = sidePanelContent === SidePanelContent.SLIDE || isPlaceholderHighlighted;

    return (
        <div className={`p-presEdit__sidebar ${isElementsTabActive ? 'p-presEdit__sidebar--secondary' : ''}`}>
            {isElementsTabActive && <EditPresSidebar />}

            {isHighlightedElementsTabActive && (
                <div key={highlightedElement.id} ref={highlightedRef} className="p-presEdit__sidebar_body">
                    <HighlightedElementComponent />
                </div>
            )}

            {isSlideTabActive && (
                <div key={highlightedElement.id} className="p-presEdit__sidebar_body">
                    <SlideSettingsForm slide={slide} />
                </div>
            )}
        </div>
    );
}

export default SidePanelWrapper;
